import { CSSProperties, memo, useEffect } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { DefinitionService } from "../../services/DefinitionService";
import { mdlHotelNotConfirmListRequest } from "../../models/service-models/notConfirm/HotelNotConfirmListRequest";

export type HotelNotConfirmSelectProps = {
    onChange?: Function;
    defaultValue?: string;
    excludedValue?: string;
    mode?: 'multiple' | 'tags' | undefined;
    style?: CSSProperties;
    hotelId?: string;
    onLoad?: Function;
    value?: any;
    onClear?: Function;
}


export const HotelNotConfirmSelect = (props: HotelNotConfirmSelectProps) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (!data)
            refetch();
    }, [props]);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getHotelNotConfirms"],
        () => {
            if (props.hotelId) {
                var request: mdlHotelNotConfirmListRequest = { pageSize: 0, hotelId: props.hotelId };
                return DefinitionService.NotConfirmList(request);
            }
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!props.hotelId
        }
    );

    useEffect(() => {
        if (data?.body?.data && props.onLoad) {
            props.onLoad(data?.body?.data);
        }
    }, [data]);

    const handleOnClear = () => {
        props.onClear && props.onClear();
    }

    return (
        <>
            <Select
                style={props.style && props.style}
                mode={props.mode && props.mode}
                loading={isLoading}
                size="large"
                maxTagCount={3}
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onChange={(value: string | string[], option: any) => props.onChange && props.onChange(value, option)}
                showSearch
                placeholder={t("definitions.notConfirm.chooseNotConfirmReasonTemplate")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                allowClear={props.onClear ? true : false}
                onClear={handleOnClear}
                options={data?.body?.data?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                })).filter((x) => !props.excludedValue || (props.excludedValue && x.value != props.excludedValue))}
            />
        </>
    )
}